import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import "../css/Hero.css";
import Footer from "./components/Footer";

const words = ["SHOP BY ARTIST", "SHOP ALL"];

const Hero = () => {
  const [nextPath, setNextPath] = useState(null);
  const [showLetters, setShowLetters] = useState(true);
  const [wiggleIndex, setWiggleIndex] = useState(null); // track which letter to wiggle
  const navigate = useNavigate();

  useEffect(() => {
    if (!window.__p5Ready) {
      const handler = () => {};
      window.addEventListener("p5Ready", handler);
      return () => window.removeEventListener("p5Ready", handler);
    }
  }, []);

  // Randomly wiggle a letter every 2 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      const wordIndex = Math.floor(Math.random() * words.length);
      const letterIndex = Math.floor(Math.random() * words[wordIndex].length);
      setWiggleIndex({ wordIndex, letterIndex });

      // reset after animation duration
      setTimeout(() => setWiggleIndex(null), 300);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleClick = (path) => (e) => {
    e.preventDefault();
    setNextPath(path);
    setShowLetters(false); // triggers AnimatePresence exit
  };

  const handleExitComplete = () => {
    if (nextPath) navigate(nextPath);
  };

  return (
    <div>
    <div className="hero-container">
      <div className="hero-buttons">
        {words.map((word, i) => (
          <div key={i} className={`button-row ${i === 0 ? "left" : "right"}`}>
            <div
              className="hero-button"
              onClick={handleClick(i === 0 ? "/collections" : "/collections/all")}
            >
              <div className="word">
                <AnimatePresence onExitComplete={handleExitComplete}>
                  {showLetters &&
                    word.split("").map((char) => (char === " " ? "\u00A0" : char)).map((char, j) => {
                      const isWiggling =
                        wiggleIndex?.wordIndex === i &&
                        wiggleIndex?.letterIndex === j;

                      return (
                        <motion.span
                          key={j}
                          // Remove initial offsets
                          initial={{ opacity: 1, x: 0, y: 0, rotate: 0 }}
                          animate={{
                            x: isWiggling ? [0, -5, 5, 0] : 0,
                            y: isWiggling ? [0, -3, 3, 0] : 0,
                            rotate: isWiggling ? [0, -10, 10, 0] : 0,
                          }}
                          exit={{
                            x: i === 0 ? -200 : 200,
                            opacity: 0,
                            transition: { duration: 0.25 },
                          }}
                          transition={isWiggling ? { duration: 0.3, type: "tween" } : {}}
                          style={{
                            display: "inline-block",
                            position: "relative",
                            willChange: "transform, opacity",
                          }}
                        >
                          {char}
                        </motion.span>
                      );
                    })}
                </AnimatePresence>
              </div>
            </div>
          </div>
        ))}
      </div>
      </div>
      <AnimatePresence>
        {showLetters && (
          <motion.div
            key="footer"
            className="footer-sticky"
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 0.4 } }}
          >
            <Footer />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Hero;